<template>
  <!--
  - Display an error if there's an error loading objects
   -->
  <mp-alert-error v-if="errors.length > 0" errors="errors">
    There was one or more errors loading Servers
  </mp-alert-error>

  <!--
  - If the component is loading display a loading block
   -->
  <mp-loading-block v-else-if="loading">
    Loading Servers
  </mp-loading-block>

  <div v-else>
    <!--
    - Display a sliding panel allow the editing of objects
     -->
    <mp-sliding-panel
      title="Edit Server"
      icon="text-single"
      subtitle="Edit the details for this server"
      :expanded="edit.show"
      @close="closeEdit"
    >
      <!--
      - Display a form allowing the editing of objects
       -->
      <edit-server-form :id="edit.id" @input="editUpdated" @close="closeEdit" />
    </mp-sliding-panel>

    <!--
    - If there are no objects, display an info panel
     -->
    <mp-alert-info v-if="servers.length <= 0" :closable="false">
      There are no servers.
    </mp-alert-info>

    <!--
    - Otherwise display a table of objects
     -->
    <mp-data-table
      v-else
      :simple-table="true"
      :total-results="servers.length"
      :headers="headers"
    >
      <!--
      - Loop through all objects returned
      -->
      <tr v-for="server in servers" :key="server.id()">
        <td class="status"><mp-status-bullet /></td>
        <td>{{ server.get("name") }}</td>
        <td>{{ server.get("address") }}</td>
        <td class="status">
          <mp-status-bullet
            :type="server.getBool('isEnabled') ? 'success' : 'danger'"
          />
        </td>

        <!--
        - Display a collections of actions for this object
        -->
        <td class="action">
          <mp-action-dropdown>
            <mp-action-dropdown-item icon="edit" @click="editObject(server)">
              Edit Server
            </mp-action-dropdown-item>
            <mp-action-dropdown-item icon="dashboard">
              View Stations
            </mp-action-dropdown-item>
            <mp-action-dropdown-item
              icon="delete"
              @click="removeObject(server)"
            >
              Remove Server
            </mp-action-dropdown-item>
          </mp-action-dropdown>
        </td>
      </tr>
    </mp-data-table>
  </div>
</template>

<script>
import { API } from "@memberpoint/mp-frontend-core";
import { ServerManager } from "../Manager/ServerManager";
import EditServerForm from "./internal/EditServerForm";

export default {
  name: "ServersServerList",
  components: { EditServerForm },
  data() {
    return {
      errors: [],
      loading: true,
      servers: [],
      headers: [
        { name: "isup", title: "Up" },
        { name: "name", title: "Name" },
        { name: "address", title: "Address" },
        { name: "enabled", title: "Enabled" },
        { name: "", title: "" }
      ],
      edit: {
        show: false,
        id: null
      }
    };
  },
  created() {
    this.load();
  },
  methods: {
    /**
     * Load up a list of all servers
     */
    load() {
      this.loading = true;
      let manager = new ServerManager();
      manager
        .getServers()
        .then(apiResponse => {
          this.servers = apiResponse.getData();
        })
        .catch(err => {
          this.errors = API.SimpleAPIErrorParser.parse(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     *
     * @param {SimpleAPIData} object
     */
    editObject(object) {
      this.edit = {
        show: true,
        id: object.id()
      };
    },

    /**
     * Fired when an edit form has been completed.
     */
    editUpdated() {
      this.load();
      this.closeEdit();
    },

    /**
     * Close the edit server panel
     */
    closeEdit() {
      this.edit = {
        show: false,
        id: null
      };
    },

    /**
     * @param {SimpleAPIData} object
     * Remove Server
     */
    removeObject(object) {
      let manager = new ServerManager();
      this.$dialog
        .confirmDelete(
          "Remove Station",
          `Are you sure you want to remove the server ${object.get("name")}`,
          object.get("name"),
          {
            onConfirm() {
              return manager.removeServer(object.id());
            }
          }
        )
        .then(() => {
          this.load();
        })
        .catch(() => {
          // Do nothing
        });
    }
  }
};
</script>

<style scoped lang="scss">
.action {
  max-width: 50px;
  text-align: right;
}
.status {
  width: 60px;
  text-align: center;
}
</style>
